module.exports = __webpack_public_path__ + "img/122.9c315e2f.jpg";